import { queryOptions, keepPreviousData } from '@tanstack/react-query';
import { systemLogsApi } from './system-logs.api';
import type { SystemLogsListParams } from '../types';

export const systemLogKeys = {
  all: ['system-logs'] as const,
  lists: () => [...systemLogKeys.all, 'list'] as const,
  list: (filters: SystemLogsListParams) =>
    [...systemLogKeys.lists(), filters] as const,
  latest: () => [...systemLogKeys.all, 'latest'] as const,
  filters: () => [...systemLogKeys.all, 'filters'] as const
};

export const systemLogQueries = {
  list: (filters: SystemLogsListParams = {}) =>
    queryOptions({
      queryKey: systemLogKeys.list(filters),
      queryFn: () => systemLogsApi.getAll(filters),
      placeholderData: keepPreviousData
    }),

  latest: () =>
    queryOptions({
      queryKey: systemLogKeys.latest(),
      queryFn: () => systemLogsApi.getLatest()
    }),

  latestPolling: (options?: { pollingEnabled?: boolean }) =>
    queryOptions({
      queryKey: systemLogKeys.latest(),
      queryFn: () => systemLogsApi.getLatest(),
      refetchInterval: options?.pollingEnabled ? 30_000 : false
    }),

  filters: () =>
    queryOptions({
      queryKey: systemLogKeys.filters(),
      queryFn: () => systemLogsApi.getFilters(),
      staleTime: 5 * 60 * 1000
    })
};
